export var CustomerTypes;
(function (CustomerTypes) {
    CustomerTypes["retail"] = "retail";
    CustomerTypes["business"] = "business";
})(CustomerTypes || (CustomerTypes = {}));
export var Distributors;
(function (Distributors) {
    Distributors["RAISIN_BUSINESS"] = "Raisin_business";
    Distributors["RAISIN"] = "Raisin";
    Distributors["PAYPAL"] = "Paypal";
})(Distributors || (Distributors = {}));
//# sourceMappingURL=customer.js.map